import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { BiEdit } from "react-icons/bi";
import { toast } from "react-toastify";
import { Badge, Form, Label, Spinner } from "reactstrap";
import { createFaqAPI, listFaqAPI, updateFaqAPI, updateFaqStatusAPI } from "../../api/faq";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import CKEditor from "../../myComponents/CK Editor/Index";
import MyDataTable from "../../myComponents/DataTable/MyDataTable";
import ConfirmModal from "../../myComponents/modals/ConfirmModal";
import Required from "../../myComponents/validate/Required";
import { decrypt, encrypt } from "../../utils/Encrypt";
import useLogout from "../../utils/Utils";
import { verifyAPI } from "../../api";
const Faq = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [mode, setMode] = useState("Add");
  const [showModal, setShowModal] = useState(false);
  // state to store response true or false of CK_Editor
  const [isCKEditor, setIsCKEditor] = useState(true);
  useEffect(() => {
    faqList();
    getVerifyDataApi();
  }, []);
  const faqList = () => {
    setIsLoading(true);
    listFaqAPI()
      .then((res) => {
        const status = decrypt(res.data.status);
        if (status === "success") {
          const decryptedResponse = decrypt(res.data.data.tableData);
          setIsLoading(false);
          toast.success(res.data.message);
          setData(decryptedResponse);
          toast.clearWaitingQueue();
        } else if (status === "failed") {
          setIsLoading(false);
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setData([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getVerifyDataApi = () => {
    const data = {};
    verifyAPI(data)
      .then((res) => {
        // decrypt data
        const status = decrypt(res.data.status);

        const dataVerify = decrypt(res.data?.data);
        if (status === "success") {
          const responseData = dataVerify.ck_editor;
          setIsCKEditor(responseData);
          toast.success(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "failed") {
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const [column, setColumn] = useState([
    {
      name: "Questions",
      selector: (row) => (
        <div>
          <p>{row?.question}</p>
          <p>{row?.hn_question}</p>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Answer",
      selector: (row) => row?.answer,
      sortable: true,
      wrap: true,
    },
    {
      name: "Answer Hindi",
      selector: (row) => row?.hn_answer,
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge
            color={`${row?.status == true ? "success" : "danger"}`}
            className={`bage bg-${row?.status == true ? "success" : "danger"}`}
          >
            {row?.status == true ? "Active" : "InActive"}
          </Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
      width: "150px",
    },
    {
      name: "Action",
      wrap: true,
      cell: (row) => (
        <div>
          <Button
            outline
            color={`warning`}
            size={`sm`}
            className={`me-1`}
            onClick={() => handleEdit(row)}
            data-toggle="tooltip"
            data-placement="top"
            title="Edit Question"
          >
            {" "}
            <BiEdit />
          </Button>
        </div>
      ),
      width: "150px",
    },
  ]);
  const handleToggleStatus = (row) => {
    setValue("id", row.id);
    setValue("status", row.status);
    setShowModal(true);
  };

  const confirmStatusChange = () => {
    const data = {
      id: watch("id"),
      status: watch("status"),
    };
    const encryptedData = encrypt(data);
    const encryptData = {
      zero: encryptedData,
    };

    // return false
    updateFaqStatusAPI(encryptData)
      .then((res) => {
        if (res.data.status == "success") {
          setIsOpen(false);
          setShowModal(false);
          setIsLoading(false);
          faqList();
          toast.success(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "failed") {
          setIsLoading(false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.state === "expired") {
          setIsLoading(false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const handleEdit = (row) => {
    setIsOpen(!isOpen);
    setMode("Edit");
    setIsOpen(true);
    setValue("id", row?.id);
    setValue("rowData", row?.row);
    setValue("question", row?.question);
    setValue("question_hn", row.hn_question);
    setTimeout(() => {
      const editorInstance = window?.CKEDITOR?.instances?.answer;
      if (editorInstance) {
        editorInstance.setData(row?.answer || "");
      } else {
        console.warn("CKEditor instance not found!");
      }
    }, 500);
    setTimeout(() => {
      const editorInstance = window?.CKEDITOR?.instances?.answer_hn;
      if (editorInstance) {
        editorInstance.setData(row?.hn_answer || "");
      } else {
        console.warn("CKEditor instance not found!");
      }
    }, 500);
  };

  const onFormSubmit = (data) => {
    let cleanedContent = "";
    let cleanedContentHN = "";
    if (isCKEditor) {
      const description = window?.CKEDITOR?.instances.answer?.getData();
      const hn_description = window?.CKEDITOR?.instances.answer_hn?.getData();
      cleanedContent = description.replace(/&nbsp;/g, " ");
      cleanedContentHN = hn_description.replace(/&nbsp;/g, " ");
    }
    const body = {
      question: data?.question,
      hn_question: data?.question_hn,
      answer: cleanedContent,
      hn_answer: cleanedContentHN,
      ...(mode == "Edit" && { id: watch("id") }),
    };
    const encryptData = encrypt(body);
    const encryptedData = {
      zero: encryptData,
    };
    // return false
    if (mode == "Add") {
      createFaqAPI(encryptedData)
        .then((res) => {
          if (res.data.status == "success") {
            setIsOpen(!isOpen);
            faqList();
            setIsLoading(false);
            setMode("Add");
            toast.success(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "failed") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.state === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err.message);
        });
    }
    if (mode == "Edit") {
      // return false
      updateFaqAPI(encryptedData)
        .then((res) => {
          const status = decrypt(res.data.status);
          if (status === "success") {
            setIsOpen(false);
            faqList();
            setIsLoading(false);
            setMode("Add");
            toast.success(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "failed") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err.message);
        });
    }
  };

  return (
    <>
      <Head title={"FAQ"} />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"FAQ"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    setMode("Add");
                    reset();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <Row className={`g-gs`}>
            {isOpen && (
              <PreviewAltCard>
                <Form onSubmit={handleSubmit(onFormSubmit)}>
                  <Row className={`g-gs`}>
                    {/*Question */}
                    <Col md="4" sm="3" xxl="6">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="question">
                          Question <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <input
                            placeholder={"Enter Question"}
                            type="text"
                            id="question"
                            {...register("question", {
                              required: {
                                value: true,
                                message: "Question is required",
                              },
                            })}
                            className="form-control"
                            value={watch("question")}
                            onChange={(e) => {
                              setValue("question", e.target.value);
                              trigger("question");
                            }}
                          />
                          {errors.question && <span className="invalid">{errors?.question?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "}
                    {/*Question */}
                    <Col md="12" sm="12" xxl="6">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="question_hn">
                          Question हिन्दी <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <input
                            placeholder={"Enter Question Hindi"}
                            type="text"
                            id="question_hn"
                            {...register("question_hn", {
                              required: {
                                value: true,
                                message: "हिंदी में प्रश्न आवश्यक है",
                              },
                            })}
                            className="form-control"
                            value={watch("question_hn")}
                            onChange={(e) => {
                              setValue("question_hn", e.target.value);
                              trigger("question_hn");
                            }}
                          />
                          {errors.question_hn && <span className="invalid">{errors?.question_hn?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "}
                    <Col md="12" sm="12" xxl="6" className="mt-3">
                      {isCKEditor ? (
                        <CKEditor title={"Answer"} id={"answer"} />
                      ) : (
                        <>
                          <Label htmlFor="answer" className="form-label">
                            {"Answer"}
                            <Required />
                          </Label>
                          <div className="form-control-wrap">
                            <textarea
                              rows={15}
                              placeholder={"Enter answer"}
                              type="text"
                              id="answer"
                              {...register("answer", {
                                required: "Answer is required",
                                // pattern: {
                                //   value: /^[a-zA-Z0-9.,/_( )\n\r-]+$/,
                                //   message:
                                //     "Only alphanumeric characters and [ , . / - _ ( )] are allowed",
                                // },
                              })}
                              className="form-control"
                              value={watch("answer")}
                              onChange={(e) => {
                                setValue("answer", e.target.value);
                                trigger("answer");
                              }}
                            />
                            {errors.answer && <span className="invalid">{errors?.answer?.message}</span>}
                          </div>
                        </>
                      )}
                    </Col>
                    <Col md="12" sm="12" xxl="6" className="mt-3">
                      {isCKEditor ? (
                        <CKEditor title={"Answer हिन्दी"} id={"answer_hn"} />
                      ) : (
                        <>
                          <Label htmlFor="answer_hn" className="form-label">
                            {"Answer हिन्दी"}
                            <Required />
                          </Label>
                          <div className="form-control-wrap">
                            <textarea
                              rows={15}
                              placeholder={"Enter answer in hindi"}
                              type="text"
                              id="answer_hn"
                              {...register("answer_hn", {
                                required: "Answer is required",
                                // pattern: {
                                //   value: /^[a-zA-Z0-9.,/_( )\n\r-]+$/,
                                //   message:
                                //     "Only alphanumeric characters and [ , . / - _ ( )] are allowed",
                                // },
                              })}
                              className="form-control"
                              value={watch("answer_hn")}
                              onChange={(e) => {
                                setValue("answer_hn", e.target.value);
                                trigger("answer_hn");
                              }}
                            />
                            {errors.answer_hn && <span className="invalid">{errors?.answer_hn?.message}</span>}
                          </div>
                        </>
                      )}
                    </Col>
                    <Col md="2" className={``}>
                      <div className="form-group" style={{ marginTop: "25px" }}>
                        <Button disabled={isLoading} color="primary" size="md" type="submit">
                          {isLoading ? <Spinner size="sm" color="primary" /> : mode === "Edit" ? "Update" : "Save"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </PreviewAltCard>
            )}
          </Row>
          <MyDataTable data={data} columns={column} title={"Faq List"} isLoading={isLoading} />
          {/* Confirmation Modal */}
          <ConfirmModal
            isOpen={showModal}
            toggle={() => setShowModal(!showModal)}
            onConfirm={confirmStatusChange}
            status={watch("status")}
          />{" "}
        </Block>
      </Content>
    </>
  );
};

export default Faq;
